<template>
  <div class="grid grid-cols-7 items-center text-gray-400">
    <div v-if="label" class="col-span-2">{{ label }}</div>
    <DInputText
      ref="inputRef"
      :class="label ? 'col-span-5' : 'col-span-7'"
      v-model="internalModelValue"
      :disabled="disabled" />
  </div>
</template>
<script setup>
import { DInputText } from '@disguise/cloud-ui';
import { ref, toRaw, toRefs, watch } from 'vue';

const props = defineProps({
  modelValue: {
    required: true,
  },
  label: {
    type: String,
    default: null,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(['update:modelValue']);

const { modelValue } = toRefs(props);
const internalModelValue = ref(structuredClone(toRaw(modelValue.value)));

watch(modelValue, () => {
  internalModelValue.value = structuredClone(toRaw(modelValue.value));
});

const handleModelValueUpdate = () => {
  emit('update:modelValue', structuredClone(toRaw(internalModelValue.value)));
};

watch(internalModelValue, () => {
  handleModelValueUpdate();
});
</script>
